import { ShieldOff } from 'lucide-react';
import { useAuth } from '../contextos/AuthContext';
import type { EstadoAcesso } from '../contextos/AuthContext';

/**
 * Sessão sem acesso. Duas situações distintas, duas explicações distintas —
 * "acesso negado" genérico deixa a pessoa sem saber o que fazer a seguir.
 *
 * Nada disso é falha: é o desenho. A configuração do Firebase é pública, então
 * criar conta é possível para qualquer um. O que não é possível é enxergar
 * algo sem um administrador ter convidado (5.4 do planejamento).
 */
type Motivo = Exclude<EstadoAcesso, 'CARREGANDO' | 'DESLOGADO' | 'LIBERADO'>;

const TEXTOS: Record<Motivo, { titulo: string; corpo: string }> = {
  SEM_PERFIL: {
    titulo: 'Acesso ainda não liberado',
    corpo:
      'O ProfitLens é privado e funciona por convite. Sua conta existe, mas o convite ainda não foi aceito. Se você recebeu um convite por e-mail, abra o link daquela mensagem — é ele que libera o acesso. Se não recebeu, peça a um administrador.',
  },
  INATIVO: {
    titulo: 'Acesso desativado',
    corpo: 'Sua conta existe, mas foi desativada por um administrador.',
  },
};

export function SemAutorizacao({ motivo }: { motivo: Motivo }) {
  const { usuarioFirebase, sair } = useAuth();
  const t = TEXTOS[motivo];

  return (
    <main className="flex min-h-screen items-center justify-center bg-papel p-6">
      <div className="flex max-w-md flex-col items-center gap-4 rounded-md border border-regua-2 bg-superficie p-8 text-center">
        <ShieldOff className="size-8 text-pend" aria-hidden />
        <h1 className="text-xl font-semibold">{t.titulo}</h1>
        <p className="text-sm text-tinta-2">{t.corpo}</p>
        {usuarioFirebase?.email && (
          <p className="font-mono text-xs text-tinta-3">{usuarioFirebase.email}</p>
        )}

        <button
          type="button"
          onClick={() => void sair()}
          className="text-xs text-tinta-3 underline-offset-2 hover:text-marca hover:underline"
        >
          Sair
        </button>
      </div>
    </main>
  );
}
